/** Session-replay tuning constants. */

export const INGEST_URL = "/api/replays/ingest";

/** How often to gzip + POST the buffered events. */
export const BATCH_MS = 5000;

/** rrweb re-emits a full snapshot this often → fast seeking + resilient chunks. */
export const CHECKOUT_MS = 3 * 60 * 1000;

/** Rotate to a fresh (chained) replay id after this long, so no replay is
 *  unbounded (bounds storage + player memory). */
export const MAX_REPLAY_MS = 30 * 60 * 1000;

/** Rage-click: N clicks within WINDOW ms inside RADIUS px → one rageclick event. */
export const RAGE_CLICKS = 3;
export const RAGE_WINDOW_MS = 1000;
export const RAGE_RADIUS_PX = 30;

/** rrweb marker classes (add to any element/region to control capture). */
export const BLOCK_CLASS = "rr-block"; // don't record this subtree at all
export const MASK_TEXT_CLASS = "rr-mask"; // record structure, mask the text
export const IGNORE_CLASS = "rr-ignore"; // ignore input events on this element
